import { SettingsComponent } from './components/settings/settings.component';
import { AboutComponent } from './components/about/about.component';
import { ReportContainerComponent } from './components/report-container/report-container.component';
import { ReportListComponent } from './components/report-list/report-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth-guard';
import { MsalRedirectComponent } from '@azure/msal-angular';

const routes: Routes = [
  // Handle MSAL redirects at the root path with prefix matching
  { 
    path: '', 
    component: MsalRedirectComponent, 
    pathMatch: 'prefix',
    // Only match when there are query parameters or fragments, which indicates an auth redirect
    matcher: (url) => {
      if (window.location.href.includes('code=') || 
          window.location.href.includes('error=') || 
          window.location.href.includes('state=')) {
        return { consumed: url };
      }
      return null;
    }
  },
  { 
    path: '',
    redirectTo: '/reports',
    pathMatch: 'full'
  },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard]},
  { path: 'about', component: AboutComponent, canActivate: [AuthGuard]},
  { path: 'reports', component: ReportListComponent, canActivate: [AuthGuard]},
  { path: 'reports/:id', component: ReportContainerComponent, outlet: "fullscreen", canActivate: [AuthGuard]},
  // Keep the auth route for explicit navigation
  { path: 'auth', component: MsalRedirectComponent },
  // Wildcard route to handle unknown paths
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
